import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import DataProvider from 'api/data-provider';
import map from 'lodash/map';
import Link from 'components/link';
import { AccordionBlock } from 'components/accordion';

import linksForum from 'src-sites/forum/links';

import Slider from './slider';
import SliderItem from './slider-item';

const bemClassesResidentials = new Bem('residentialComplexItem');

export default class SliderProvider extends Component {
  static propTypes = {
    className: PropTypes.string,
    url: PropTypes.string,
    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    queryWord: PropTypes.string,
    preloaded: PropTypes.shape({})
  };

  constructor(...props) {
    super(...props);
    this.chooseRenderer = this.chooseRenderer.bind(this);
    this.renderTagsItem = this.renderTagsItem.bind(this);
  }

  // Show on bottom page.
  getTags(data) {
    if (!data || !data.length) return null;

    const title = data[0].tag ? `Новостройки "${data[0].tag.name}"` : 'Новостройки';
    return (
      <AccordionBlock
        panelTopic={title}
        trackAs={`${data[0].tag.name}TagBlock`}
        latestItemId={Math.max(...map(data, it => it.id))}
      >
        <Slider data={data} renderContent={this.renderTagsItem} />
        {data.length > 1 &&
          <Link
            {...bemClassesResidentials('link', 'seeAll')}
            builder={linksForum.sectionTags}
            builderProps={{ tag: data[0].tag.name, title: 'Смотреть все' }}
          >
            <span {...bemClassesResidentials('linkContent')}>
              <span {...bemClassesResidentials('text')}>Смотреть все</span>
            </span>
          </Link>
        }
      </AccordionBlock>
    );
  }

  // Show on top page.
  getNewbuild(data) {
    if (!data || !data.length) return null;

    return map(data, (it) => {
      if (it.id && it.images && it.images[0]) {
        return (
          <AccordionBlock
            key={it.id}
            panelTopic={`Подробно о ${it.name}`}
            trackAs={`${it.id}NewBuilds`}
            latestItemId={it.id}
          >
            <SliderItem data={it} className={this.props.className} />
          </AccordionBlock>
        );
      }

      return null;
    });
  }

  chooseRenderer(val = {}) {
    if (this.props.queryWord === 'tag') return this.getTags(val.data);
    return this.getNewbuild(val.data);
  }

  renderTagsItem(data) {
    return (
      <SliderItem
        data={data}
        className={this.props.className}
        withLinkAndHeader
      />
    );
  }

  render() {
    const { id, url, queryWord, preloaded } = this.props;

    return (
      <DataProvider
        url={url}
        query={{ [queryWord]: id }}
        renderer={this.chooseRenderer}
        preloaded={preloaded}
      />
    );
  }
}
